import React from "react";
import "./CardsSection.scss";
import {
  firstCardImg,
  fourthCardImg,
  secCardImg,
  thirdCardImg,
} from "../../../../assets/images/images";
import PrimaryButton from "../../../../common/primaryButton";
import { headerVideo } from "../../../../assets/videos/videos";

const CardsSection = () => {
  return (
    <section className="section cards-section">
      <div className="container">
        <div className="grid-container">
          <div className="card" data-aos="fade-right">
            <div className="heading">
              <span>01</span>
              <h3>
                A few cells are collected from your embryo for genetic analysis
              </h3>
            </div>
            <div className="img">
              <span>using next-gen sequencing systems</span>
              <img src={firstCardImg} alt="card-img" />
            </div>
            <div className="footer">
              <p>The embryo does not leave your IVF center.</p>
            </div>
          </div>
          <div className="card" data-aos="fade-left">
            <div className="heading">
              <span>02</span>
              <h3>Gattaca Genomic's lab</h3>
            </div>
            <div className="img">
              <img src={secCardImg} alt="card-img" />
            </div>
            <div className="footer">
              <p>
                The cells are transported to Gattaca Genomic's lab where the
                samples undergoes analysis.
              </p>
            </div>
          </div>
        </div>
        <div className="grid-container last">
          <div className="card" data-aos="fade-right">
            <div className="heading">
              <span>03</span>
              <h3>A detailed report will be securely sent to your physician</h3>
            </div>
            <div className="img">
              <img src={thirdCardImg} alt="card-img" />
            </div>
            <div className="footer">
              <p>
                The results are communicated to the fertility specialist and
                patient allowing them to make informed decisions together.
              </p>
            </div>
          </div>
          <div className="last-column" data-aos="fade-left">
            <div className="card">
              <div className="heading">
                <span>04</span>
                <h3>
                  Your physician will help you make the best, informed decision
                </h3>
              </div>
              <div className="img">
                <img src={fourthCardImg} alt="card-img" />
              </div>
              <div className="footer">
                <p>
                  With data in hand, your physician can help you make educated
                  decisions, leading to a successful pregnancy.
                </p>
              </div>
            </div>
            <div className="card last-card">
              <div className="video-wrapper">
                <video autoPlay muted loop playsInline data-aos="fade-up">
                  <source src={headerVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div className="heading">
                <span>05</span>
                <h3>Expert independent, board-certified genetic counseling</h3>
              </div>
              <div className="footer">
                <p>
                  Honest, unbiased report analysis, guiding patients to make
                  informed decisions.
                </p>
                <PrimaryButton
                  primaryBtnText="Get Started"
                  primaryExternalLink={"https://portal.gattacagenomics.com/"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CardsSection;
